import { render, staticRenderFns } from "./RelatorioPixEnviados.vue?vue&type=template&id=02232d26"
import script from "./RelatorioPixEnviados.vue?vue&type=script&lang=ts"
export * from "./RelatorioPixEnviados.vue?vue&type=script&lang=ts"
import style0 from "./RelatorioPixEnviados.vue?vue&type=style&index=0&id=02232d26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports